// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-check-circle-filled
 * @tagname hzn-icon-check-circle-filled
 * @summary An individual icon for Horizon
 */
export class HznIconCheckCircleFilled extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.5355 7.53553L9.75736 15.3137L6.22183 11.7782L4.80761 13.1924L9.05025 17.435C9.44078 17.8256 10.0739 17.8256 10.4645 17.435L18.9497 8.94975L17.5355 7.53553Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=check-circle-filled.js.map